import React from "react";
import "./Home.css";
import UK from "../../assets/UK.png";

function Home() {
  const medias = {
    social_media: [
      {
        name: "Facebook",
        url: "https://www.facebook.com/utsab.khatiwada.2/",
        icon: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg",
        color: "#1877F2",
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/utsab-khatiwada-12a24619b/",
        icon: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg",
        color: "#0A66C2",
      },
      {
        name: "GitHub",
        url: "https://github.com/Utsab-crompoide",
        icon: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg",
        color: "#ffffff",
      },
      {
        name: "Twitter",
        url: "https://x.com/_crompoide",
        icon: "https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/twitter.svg",
        color: "#1DA1F2",
      },
    ],
  };

  return (
    <div className="appHome">
      <div className="homeContent">
        <div className="spacer">
          <h1 className="intro">
            Hello, I’m <span className="bold">Utsab Khatiwada.</span>
            <br />
            <span className="bold">Fullstack</span> <span className="gradient-text bold">Developer</span>
            <br />
            Based in <span className="bold">Nepal.</span>
          </h1>
          <h3 className="description">
          Software Developer specializing in .NET, AWS, Java, and React Native, with experience building scalable web and mobile applications. Focused on writing clean, efficient code and continuously expanding technical expertise to deliver reliable software solutions.
          </h3>
        </div>
        <img src={UK} alt="Utsab Khatiwada" className="ownImage"></img>
      </div>
      <div className="socialMedia">
        {medias?.social_media.map((media, index) => (
          <a key={index} href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: media.color }}>
            <img src={media.icon} alt={media.name} className="socialIcon" />
          </a>
        ))}
      </div>
    </div>
  );
}

export default Home;
